import { render } from "./NavIcon.vue?vue&type=template&id=1481af30&scoped=true"
import script from "./NavIcon.vue?vue&type=script&lang=js"
export * from "./NavIcon.vue?vue&type=script&lang=js"

import "./NavIcon.vue?vue&type=style&index=0&id=1481af30&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1481af30"]])

export default __exports__